module.exports = __webpack_public_path__ + "img/40_38_049_550.d8a180fa.jpg";